package com.yogaaicoach.pages.dashboard

import com.yogaaicoach.common.ui.components.*
import react.ChildrenBuilder
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

internal external interface OnboardingPageProps : Props {
    var onAddNewTraining: () -> Unit
    var onNavigateToTest: () -> Unit
}

// Pixel-matched against OnboardingScreen.kt + HeroCard.kt + OnboardingHeroCard.kt +
// OnboardingThreeStepProgram.kt + FreeTrialBanner.kt. Layout responsiveness (hero card's single
// column vs. first-column-plus-highlights, three-step row vs. column) uses CSS media queries
// instead of a JS-computed isSmallScreen, since the breakpoint behavior is purely visual.
internal val OnboardingPage = FC<OnboardingPageProps> { props ->
    div {
        className = ClassName("onboarding-page")

        FreeTrialBannerIfNeeded()
        TestButtonIfTestEnv(props.onNavigateToTest)

        div {
            className = ClassName("hero-image-strip")
            img { className = ClassName("hero-image"); src = "first_page_horizontal.jpeg"; alt = "" }
            div { className = ClassName("hero-image-fade") }
        }

        div {
            className = ClassName("hero-card")

            div {
                className = ClassName("hero-badge-row hero-badge-row-top-padded")
                AutoAwesomeIcon {}
                span { +"New Member" }
            }

            h2 { className = ClassName("hero-title"); +"Ready to Begin?" }

            button {
                className = ClassName("hero-cta-button")
                onClick = { props.onAddNewTraining() }
                span { +"Create My Program" }
                AutoAwesomeIconWhite {}
            }

            p {
                className = ClassName("hero-subtitle")
                +"Create your personalized yoga program tailored to your goals, schedule, and experience level."
            }

            HighlightsSection()
        }

        div {
            className = ClassName("three-step-card")
            h3 { className = ClassName("three-step-title"); +"Getting Started in 3 Simple Steps" }
            p { className = ClassName("three-step-subtitle"); +"Follow these steps to begin your practice" }

            div {
                className = ClassName("steps-row")
                StepCard(CenterFocusStrongIcon, "Choose Your Goals", "Tell us what you want to achieve")
                StepCard(CalendarMonthIcon, "Set Your Schedule", "Pick how often you want to train")
                StepCard(AutoAwesomeIcon, "Get Your Program", "We'll build it for you")
            }
        }
    }
}

// Shared with NoActiveProgramPage.kt — HeroCard.kt's HighlightsSection() is used by both
// HeroCardFirstColumn (small screens) and HeroCardSecondColumn (large screens) regardless of
// which screen's HeroCardFirstColumn content is shown.
internal fun ChildrenBuilder.HighlightsSection() {
    div {
        className = ClassName("highlights-section")
        div {
            className = ClassName("highlights-row")
            HighlightBadge(TargetIcon, "100%", "Personalized")
            HighlightBadge(CalendarMonthIcon, "Flexible", "Schedule")
        }
        HighlightBadge(AutoAwesomeIcon, "Just For You", "Tailored to Your Goals", fullWidth = true)
    }
}

internal fun ChildrenBuilder.HighlightBadge(icon: react.FC<Props>, title: String, text: String, fullWidth: Boolean = false) {
    div {
        className = ClassName(if (fullWidth) "highlight-badge highlight-badge-full" else "highlight-badge")
        icon {}
        span { className = ClassName("highlight-badge-title"); +title }
        span { className = ClassName("highlight-badge-text"); +text }
    }
}

private fun ChildrenBuilder.StepCard(icon: react.FC<Props>, title: String, description: String) {
    div {
        className = ClassName("step-card")
        icon {}
        p { className = ClassName("step-card-title"); +title }
        p { className = ClassName("step-card-text"); +description }
    }
}
